module.exports = __webpack_public_path__ + "static/media/3.e57dbd14.jpeg";